import React from "react";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { configs } from "./config";

render(
  <BrowserRouter basename={configs?.basePath || "/"}>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
